import { ReactNode } from 'react';

export enum ModalType {
    ModalClosed = 'modalClosed',
    ModalRequested = 'modalRequested',
}

export interface ModalClosedAction {
    type: ModalType.ModalClosed;
}

export interface ModalRequestedAction {
    type: ModalType.ModalRequested;
    button: ReactNode;
    content: ReactNode;
    title: string | ReactNode;
    className?: string;
}

export const modalClosed = (): ModalClosedAction => ({
    type: ModalType.ModalClosed,
});

export const modalRequested = (
    button: ReactNode,
    child: ReactNode,
    title: string | ReactNode,
    className?: string,
): ModalRequestedAction => ({
    type: ModalType.ModalRequested,
    button,
    content: child,
    title,
    className,
});

export type ModalActionTypes = ModalClosedAction | ModalRequestedAction;
